// import React, { useState } from 'react';
import Pointer from "./Pointer";
import {useStore} from "../store";
import styled from "styled-components";
import { size }  from "../utlis/device";
import { device }  from "../utlis/device";

const OmeterContainer = styled.div ` 
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 0px 40px 0px 40px; 
  padding-top: 0px;
  /* margin: auto; */
  z-index: 0;
  @media (max-width: ${size.tablet}) {

  }
  /* width: 100%; */
`

const OmeterBackground = styled.img `
   width: 500px;
   padding: 100px;
  padding-top: 0px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  @media ${device.mobileL} {
    width: 400px;
  }
  @media ${device.mobileM} {
    width: 400px;
  }
  @media (max-width: 380px) {
    width: 340px;
  }
  @media (max-width: 320px) {
    width: 300px;
  }
  @media ${device.mobileS} {
    width: 300px;
  }
  @media (max-width: 280px) {
    width: 280px;
  }
`

function Ometer() {
  const rotation = useStore((state) => state.rotation);

  return (
    
    <OmeterContainer>
      <OmeterBackground src="/images/EastDevonNiceOMetre.png" alt='ometer' />
      <Pointer rotation={rotation} />
    </OmeterContainer>
  );
}

export default Ometer;
